export function getOnboardingFlow(onboardingFlowRepository) {
  return onboardingFlowRepository.get()
}